/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiSettingsUnitsCreateSettingsUnitPost } from '../fn/settings-units/api-settings-units-create-settings-unit-post';
import { ApiSettingsUnitsCreateSettingsUnitPost$Params } from '../fn/settings-units/api-settings-units-create-settings-unit-post';
import { apiSettingsUnitsCreateSettingsUnitPost$Plain } from '../fn/settings-units/api-settings-units-create-settings-unit-post-plain';
import { ApiSettingsUnitsCreateSettingsUnitPost$Plain$Params } from '../fn/settings-units/api-settings-units-create-settings-unit-post-plain';
import { apiSettingsUnitsDeleteSettingsUnitDelete } from '../fn/settings-units/api-settings-units-delete-settings-unit-delete';
import { ApiSettingsUnitsDeleteSettingsUnitDelete$Params } from '../fn/settings-units/api-settings-units-delete-settings-unit-delete';
import { apiSettingsUnitsDeleteSettingsUnitDelete$Plain } from '../fn/settings-units/api-settings-units-delete-settings-unit-delete-plain';
import { ApiSettingsUnitsDeleteSettingsUnitDelete$Plain$Params } from '../fn/settings-units/api-settings-units-delete-settings-unit-delete-plain';
import { apiSettingsUnitsGetSettingsUnitsPost } from '../fn/settings-units/api-settings-units-get-settings-units-post';
import { ApiSettingsUnitsGetSettingsUnitsPost$Params } from '../fn/settings-units/api-settings-units-get-settings-units-post';
import { apiSettingsUnitsGetSettingsUnitsPost$Plain } from '../fn/settings-units/api-settings-units-get-settings-units-post-plain';
import { ApiSettingsUnitsGetSettingsUnitsPost$Plain$Params } from '../fn/settings-units/api-settings-units-get-settings-units-post-plain';
import { apiSettingsUnitsUpdateSettingsUnitPatch } from '../fn/settings-units/api-settings-units-update-settings-unit-patch';
import { ApiSettingsUnitsUpdateSettingsUnitPatch$Params } from '../fn/settings-units/api-settings-units-update-settings-unit-patch';
import { apiSettingsUnitsUpdateSettingsUnitPatch$Plain } from '../fn/settings-units/api-settings-units-update-settings-unit-patch-plain';
import { ApiSettingsUnitsUpdateSettingsUnitPatch$Plain$Params } from '../fn/settings-units/api-settings-units-update-settings-unit-patch-plain';
import { CreateSettingsUnitCommandResult } from '../models/create-settings-unit-command-result';
import { DeleteSettingsUnitCommandResult } from '../models/delete-settings-unit-command-result';
import { GetUnitsQueryResult } from '../models/get-units-query-result';
import { UpdateSettingsUnitCommandResult } from '../models/update-settings-unit-command-result';

@Injectable({ providedIn: 'root' })
export class SettingsUnitsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiSettingsUnitsGetSettingsUnitsPost()` */
  static readonly ApiSettingsUnitsGetSettingsUnitsPostPath = '/api/SettingsUnits/GetSettingsUnits';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsUnitsGetSettingsUnitsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsUnitsGetSettingsUnitsPost$Plain$Response(params?: ApiSettingsUnitsGetSettingsUnitsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUnitsQueryResult>> {
    return apiSettingsUnitsGetSettingsUnitsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSettingsUnitsGetSettingsUnitsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsUnitsGetSettingsUnitsPost$Plain(params?: ApiSettingsUnitsGetSettingsUnitsPost$Plain$Params, context?: HttpContext): Observable<GetUnitsQueryResult> {
    return this.apiSettingsUnitsGetSettingsUnitsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetUnitsQueryResult>): GetUnitsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsUnitsGetSettingsUnitsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsUnitsGetSettingsUnitsPost$Response(params?: ApiSettingsUnitsGetSettingsUnitsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUnitsQueryResult>> {
    return apiSettingsUnitsGetSettingsUnitsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSettingsUnitsGetSettingsUnitsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsUnitsGetSettingsUnitsPost(params?: ApiSettingsUnitsGetSettingsUnitsPost$Params, context?: HttpContext): Observable<GetUnitsQueryResult> {
    return this.apiSettingsUnitsGetSettingsUnitsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetUnitsQueryResult>): GetUnitsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiSettingsUnitsCreateSettingsUnitPost()` */
  static readonly ApiSettingsUnitsCreateSettingsUnitPostPath = '/api/SettingsUnits/CreateSettingsUnit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsUnitsCreateSettingsUnitPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsUnitsCreateSettingsUnitPost$Plain$Response(params?: ApiSettingsUnitsCreateSettingsUnitPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateSettingsUnitCommandResult>> {
    return apiSettingsUnitsCreateSettingsUnitPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSettingsUnitsCreateSettingsUnitPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsUnitsCreateSettingsUnitPost$Plain(params?: ApiSettingsUnitsCreateSettingsUnitPost$Plain$Params, context?: HttpContext): Observable<CreateSettingsUnitCommandResult> {
    return this.apiSettingsUnitsCreateSettingsUnitPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateSettingsUnitCommandResult>): CreateSettingsUnitCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsUnitsCreateSettingsUnitPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsUnitsCreateSettingsUnitPost$Response(params?: ApiSettingsUnitsCreateSettingsUnitPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateSettingsUnitCommandResult>> {
    return apiSettingsUnitsCreateSettingsUnitPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSettingsUnitsCreateSettingsUnitPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsUnitsCreateSettingsUnitPost(params?: ApiSettingsUnitsCreateSettingsUnitPost$Params, context?: HttpContext): Observable<CreateSettingsUnitCommandResult> {
    return this.apiSettingsUnitsCreateSettingsUnitPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateSettingsUnitCommandResult>): CreateSettingsUnitCommandResult => r.body)
    );
  }

  /** Path part for operation `apiSettingsUnitsUpdateSettingsUnitPatch()` */
  static readonly ApiSettingsUnitsUpdateSettingsUnitPatchPath = '/api/SettingsUnits/UpdateSettingsUnit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsUnitsUpdateSettingsUnitPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsUnitsUpdateSettingsUnitPatch$Plain$Response(params?: ApiSettingsUnitsUpdateSettingsUnitPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateSettingsUnitCommandResult>> {
    return apiSettingsUnitsUpdateSettingsUnitPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSettingsUnitsUpdateSettingsUnitPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsUnitsUpdateSettingsUnitPatch$Plain(params?: ApiSettingsUnitsUpdateSettingsUnitPatch$Plain$Params, context?: HttpContext): Observable<UpdateSettingsUnitCommandResult> {
    return this.apiSettingsUnitsUpdateSettingsUnitPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateSettingsUnitCommandResult>): UpdateSettingsUnitCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsUnitsUpdateSettingsUnitPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsUnitsUpdateSettingsUnitPatch$Response(params?: ApiSettingsUnitsUpdateSettingsUnitPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateSettingsUnitCommandResult>> {
    return apiSettingsUnitsUpdateSettingsUnitPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSettingsUnitsUpdateSettingsUnitPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsUnitsUpdateSettingsUnitPatch(params?: ApiSettingsUnitsUpdateSettingsUnitPatch$Params, context?: HttpContext): Observable<UpdateSettingsUnitCommandResult> {
    return this.apiSettingsUnitsUpdateSettingsUnitPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateSettingsUnitCommandResult>): UpdateSettingsUnitCommandResult => r.body)
    );
  }

  /** Path part for operation `apiSettingsUnitsDeleteSettingsUnitDelete()` */
  static readonly ApiSettingsUnitsDeleteSettingsUnitDeletePath = '/api/SettingsUnits/DeleteSettingsUnit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsUnitsDeleteSettingsUnitDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsUnitsDeleteSettingsUnitDelete$Plain$Response(params?: ApiSettingsUnitsDeleteSettingsUnitDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteSettingsUnitCommandResult>> {
    return apiSettingsUnitsDeleteSettingsUnitDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSettingsUnitsDeleteSettingsUnitDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsUnitsDeleteSettingsUnitDelete$Plain(params?: ApiSettingsUnitsDeleteSettingsUnitDelete$Plain$Params, context?: HttpContext): Observable<DeleteSettingsUnitCommandResult> {
    return this.apiSettingsUnitsDeleteSettingsUnitDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteSettingsUnitCommandResult>): DeleteSettingsUnitCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsUnitsDeleteSettingsUnitDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsUnitsDeleteSettingsUnitDelete$Response(params?: ApiSettingsUnitsDeleteSettingsUnitDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteSettingsUnitCommandResult>> {
    return apiSettingsUnitsDeleteSettingsUnitDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSettingsUnitsDeleteSettingsUnitDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsUnitsDeleteSettingsUnitDelete(params?: ApiSettingsUnitsDeleteSettingsUnitDelete$Params, context?: HttpContext): Observable<DeleteSettingsUnitCommandResult> {
    return this.apiSettingsUnitsDeleteSettingsUnitDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteSettingsUnitCommandResult>): DeleteSettingsUnitCommandResult => r.body)
    );
  }

}
